import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ChartGanttIcon, CreditCardIcon, FileTextIcon, GaugeIcon, PuzzleIcon } from "lucide-react";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";

const BillingLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setPage } = useBreadcrumbs();

  useEffect(() => {
    setPage("Manage Organisation");
  }, []);

  const getActiveTab = () => {
    if (location.pathname.includes("/billing/invoices") || location.pathname.includes("/billing/transactions")) {
      return "billing/invoices";
    }

    if (location.pathname.includes("/billing/add-ons")) {
      return "billing/add-ons";
    }

    if (location.pathname.includes("/billing/plan")) {
      return "billing/plan";
    }

    if (location.pathname.includes("/billing/usage")) {
      return "billing/usage";
    }

    return "billing/overview";
  };

  const handleTabChange = (value: string) => {
    navigate(`/manage-organisation/${value}`);
  };

  return (
    <div className="flex flex-col h-full">
      <div className="border-b border-border p-4">
        <Tabs value={getActiveTab()} onValueChange={handleTabChange}>
          <TabsList>
            <TabsTrigger value="billing/overview" className="gap-2">
              <CreditCardIcon className="h-4 w-4" />
              Overview
            </TabsTrigger>
            <TabsTrigger value="billing/plan" className="gap-2">
              <ChartGanttIcon className="h-4 w-4" />
              Plan
            </TabsTrigger>
            <TabsTrigger value="billing/add-ons" className="gap-2">
              <PuzzleIcon className="h-4 w-4" />
              Add-ons
            </TabsTrigger>
            <TabsTrigger value="billing/usage" className="gap-2">
              <GaugeIcon className="h-4 w-4" />
              Usage
            </TabsTrigger>
            <TabsTrigger value="billing/invoices" className="gap-2">
              <FileTextIcon className="h-4 w-4" />
              Invoices
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default BillingLayout;
